import { Api } from '../Services/Api'

export function archiveEntityById(scriptId, type = 'scripts') {
    return Api()
        .patch(`api/${type}/archive/${scriptId}`)
        .then((response) => {
            return response
        })
}
